import { checkResponse, parseJSONDate } from "src/components/js/statics1";
import { socketOnSave } from "../system/socketClass";
import { cache_read, cache_write, general_cacheName } from "src/components/js/CacheFunctions";
import { gridKeikka_copyJSON } from "src/pages/Grid/GridKeikka/gridKeikkaFunctions";

export default class gridPalkkiClass {
  constructor(pvm, vehicleId, ownerAsiakasId) {
    this.keikkaId = null;
    this.palkkiId = null;
    // starttime at pvm 07:00
    const st = new Date(pvm);
    st.setHours(7, 0, 0, 0);
    this.timeStart = st;
    // endtime at pvm 16:00
    const et = new Date(pvm);
    et.setHours(16, 0, 0, 0);
    this.pumppuAika = st;
    this.pumppuKesto = 9 * 60;
    this.timeEnd = et;
    this.vehicleId = vehicleId;
    this.keikkaId = null;
    this.text = "";
    this.style = null;
    this.ownerAsiakasId = ownerAsiakasId;
    this.grid_palkkiTypeId = 4; // kommentti
    this.grid_palkkiType = "kommentti";
    this.grid_palkkiTypeDescription = "";
    this.deletedTime = null;
    this.kuskit = [];
    this.isKeikka = false;
    this.isPalkki = true;
    this.keikkaTilaId = -100;
    this.keikkaTilaCategory = "palkki";
    this.keikkaTilaSelite = "todo:palkki_type_text_here";
    this.hideToolTip = false;
  }
  async init(ownerAsiakasId, starttime, endtime, token) {
    const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/grid/palkki/list";
    endtime;
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
        "Cache-Control": 10,
      },
      body: JSON.stringify({ ownerAsiakasId, starttime, endtime }),
    };
    const response = await fetch(fullUrl, requestOptions);
    const cResponse = await checkResponse(response, "gridPalkkiClass.init");
    if (cResponse.success) {
      this.processCResponse(cResponse);
    }
  }
  async copyPalkki(palkki, token, socket, personId) {
    this.palkkiId = null;
    this.timeStart = palkki.timeStart;
    this.timeEnd = palkki.timeEnd;
    this.vehicleId = palkki.vehicleId;
    this.keikkaId = palkki.keikkaId;
    this.text = palkki.text || palkki.keikkaComment;
    this.keikkaComment = palkki.text || palkki.keikkaComment;
    this.style = palkki.style;
    this.ownerAsiakasId = palkki.ownerAsiakasId;
    this.deletedTime = palkki.deletedTime;
    this.palkkiTypeId = palkki.palkkiTypeId;
    this.grid_palkkiType = palkki.grid_palkkiType;
    this.grid_palkkiTypeDescription = palkki.grid_palkkiTypeDescription;
    this.kuskit = palkki.kuskit;
    this.isKeikka = palkki.isKeikka;
    this.isPalkki = palkki.isPalkki;
    this.keikkaTilaId = palkki.keikkaTilaId;
    this.keikkaTilaCategory = palkki.keikkaTilaCategory;
    this.keikkaTilaSelite = palkki.keikkaTilaSelite;
    this.grid_palkkiTypeId = palkki.grid_palkkiTypeId;
    this.grid_palkkiType = palkki.grid_palkkiType;
    this.grid_palkkiTypeDescription = palkki.grid_palkkiTypeDescription;
    const success = await this.saveToDb(token, socket, personId);

    return success;
  }

  processCResponse(cResponse) {
    this.palkkiId = cResponse.data.grid_palkki_id;
    this.timeStart = cResponse.data.starttime;
    this.timeEnd = cResponse.data.endtime;
    this.vehicleId = cResponse.data.vehicleId;
    this.keikkaId = cResponse.data.keikkaId;
    this.text = cResponse.data.text;
    this.style = cResponse.data.style;
    this.ownerAsiakasId = cResponse.data.ownerAsiakasId;
    this.deletedTime = cResponse.data.deletedTime;
    this.palkkiTypeId = cResponse.data.palkkiTypeId;
    this.grid_palkkiType = cResponse.data.palkkiType;
  }
  async saveToDb(token, socket, personId) {
    const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/grid/palkki/save";
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: gridKeikka_copyJSON(this, true), //  JSON.stringify(this)
    };
    const response = await fetch(fullUrl, requestOptions);
    const cResponse = await checkResponse(response, "gridPalkkiClass.saveToDb");

    // send socket event
    const s = new socketOnSave(personId, socket, null, "gridPalkki", "save");
    s.gridPalkki = this;
    s.emitSave();
    return cResponse.success ? cResponse.data.returnValue : null;
  }
  static async saveToDbStatic(palkki, token, socket = null, personId = null) {
    const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/grid/palkki/save";
    const requestOptions = {
      method: "POST",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
      body: gridKeikka_copyJSON(palkki, true),
    };
    const response = await fetch(fullUrl, requestOptions);

    if (!response.ok) {
      console.log("Error saving palkki to DB", response.status, response.statusText);
      return { success: false, error: response.statusText, message: "Error saving palkki to DB !" };
    }

    // send socket event
    const s = new socketOnSave(
      personId,
      socket,
      palkki.ownerAsiakasId,
      "gridPalkki",
      "save",
      this.keikkaId
    );
    s.gridPalkki = palkki;
    s.emitSave();
    const cResponse = await checkResponse(response, "gridPalkkiClass.saveToDbStatic");
    return cResponse;
  }
  static async deleteStatic(palkkiId, token, socket, personId) {
    const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/grid/palkki/delete/" + palkkiId;
    const requestOptions = {
      method: "DELETE",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(fullUrl, requestOptions);

    // send socket event
    const s = new socketOnSave(personId, socket, null, "gridPalkki", "delete", palkkiId);
    s.gridPalkki.palkkiId = palkkiId;
    s.emitSave();

    return response.ok;
  }
  async delete(token, socket = null, personId = null) {
    const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/grid/palkki/delete/" + this.palkkiId;
    const requestOptions = {
      method: "DELETE",
      headers: {
        "x-access-token": `${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(fullUrl, requestOptions);

    // send socket event
    const s = new socketOnSave(personId, socket, null, "gridPalkki", "delete");
    s.gridPalkki.palkkiId = this.palkkiId;
    s.emitSave();

    return response.ok;
  }
  static getKeikkaFromPalkki(palkki) {
    if (!palkki.id) palkki.id = palkki.palkkiId || palkki.grid_palkki_Id || palkki.keikka_id;
    if (palkki.id) {
      const startTime = parseJSONDate(palkki.starttime);
      const endTime = parseJSONDate(palkki.endtime);
      return {
        id: palkki.id,
        keikkaId: "p" + (palkki.keikka_id || palkki.id),
        palkkiId: palkki.id,
        keikkaComment: palkki.text,
        grid_palkkiTypeId: palkki.grid_palkkiTypeId,
        grid_palkkiType: palkki.grid_palkkiType,
        grid_palkkiDescription: palkki.grid_palkkiDescription,
        keikkaTilaId: -100,
        keikkaTilaCategory: "palkki",
        keikkaTilaSelite: "todo:palkki_type_text_here",
        ownerAsiakasId: palkki.ownerAsiakasId,
        pumppuAika: startTime,
        pumppuKesto: (endTime - startTime) / 60000,
        timeStart: startTime,
        timeEnd: endTime,
        vehicleId: palkki.vehicleId,
        isKeikka: false,
        isPalkki: true,
        deletedTime: palkki.deletedTime,
        kuskit: [],
        hideToolTip: palkki.hideToolTip || false,
      };
    }
    return null;
  }
  static createTempPalkkiKeikka(
    startTime,
    endTime,
    vehicleId,
    text,
    style,
    ownerAsiakasId,
    grid_palkkiTypeId = 9,
    grid_palkkiTypeDescription = "Ei tietoa!",
    id = null
  ) {
    if (!id) id = Math.floor(Math.random() * 1000000);

    const _tempPalkki = {
      id: id,
      keikkaId: "temp" + id,
      palkkiId: "temp" + id,
      starttime: startTime,
      endtime: endTime,
      vehicleId: vehicleId,
      text: text,
      style: style,
      ownerAsiakasId: ownerAsiakasId,
      palkkiType: null,
      deletedTime: null,
      grid_palkkiTypeId: grid_palkkiTypeId,
      grid_palkkiType: grid_palkkiTypeDescription,
      grid_palkkiDescription: "", //"Rajoitettu käyttöoikeus ajoneuvon kalenteritietoihin!",
    };
    const _tempKeikka = gridPalkkiClass.getKeikkaFromPalkki(_tempPalkki);
    _tempKeikka.isTemp = true;
    return _tempKeikka;
  }
  static async getStaticData(ownerAsiakasId) {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const fullUrl = import.meta.env.VITE_SERVER_URL + "/api/grid/getStaticData/" + ownerAsiakasId;
    const c = cache_read(general_cacheName, fullUrl);
    if (c) return c;

    const response = await fetch(fullUrl, requestOptions);
    const cResponse = await checkResponse(response, "gridPalkkiClass.getStaticData");
    if (!cResponse.success) {
      console.log(cResponse);
      return [];
    }
    const result = cResponse.data;
    // sort gridTypes by sortNo
    result.gridTypes.sort((a, b) => {
      if (a.sortNo < b.sortNo) return -1;
      if (a.sortNo > b.sortNo) return 1;
      return 0;
    });
    cache_write(general_cacheName, fullUrl, result, 3600);
    return result;
  }
}
